import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'fidelitySGFacilitatorTable',
    label: 'Facilitator Summary Table',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
